import React from 'react';

import { Button } from '@uhg-abyss/web/ui/Button';

interface PromptOptionProps {
  text: string;
  onPress: () => void;
}

const PromptOption: React.FC<PromptOptionProps> = ({ text, onPress }) => {
  return (
    <div>
      <Button
        variant="outline"
        color="brand"
        size="lg"
        onClick={onPress}
        aria-label={text}
        css={{
          'abyss-button-root': {
            justifyContent: 'flex-start',
            textAlign: 'left',
            borderRadius: '$core.border-radius.xxl',
            borderColor: '$core.color.brand.60',
            padding: '6px 15px',
            minHeight: 35,
            fontSize: 14,
            float: 'right',
          },
          'abyss-button-content-container': {
            color: '$core.color.brand.60',
          },
        }}
      >
        {text}
      </Button>
    </div>
  );
};

export default PromptOption;
